export class PractitionerStatus {
  private readonly key: string;
  private readonly description: string;

  constructor(key: string, description: string) {
    this.key = key;
    this.description = description;
  }

  public getKey(): string {
    return this.key;
  }

  public getDescription(): string {
    return this.description;
  }
}
